import type { StaticImageData } from 'next/image';
import ErrorSvg from 'public/img/illustrations/error-document.svg';
import type { PropsWithChildren } from 'react';
import { Spinner } from 'src/components/Spinner';
import { WholePageError } from 'src/components/WholePageError';
import { useUser } from 'src/modules/authentication/useUser';

export function WithFullUser({ children }: PropsWithChildren) {
  const { isLoading, error } = useUser();

  if (isLoading) {
    return <Spinner fullScreen />;
  }

  if (error !== undefined) {
    return <WholePageError svg={ErrorSvg as StaticImageData} sx={{ mt: 10 }} />;
  }

  return <>{children}</>;
}
